import "./aboutus.css";
import team1 from "../../assets/images/team1.png";
import team2 from "../../assets/images/team2.png";
import team3 from "../../assets/images/team3.png";
import team4 from "../../assets/images/team4.png";
import team5 from "../../assets/images/team5.png";
import team6 from "../../assets/images/team6.png";
import team7 from "../../assets/images/team7.png";
import team8 from "../../assets/images/team8.png";
import team9 from "../../assets/images/team9.png";
import team10 from "../../assets/images/team10.png";

const Index = () => {
  const teamMembers = [
    { id: 1, name: "Emmanuel Olabiran", role: "Design", image: team1 },
    { id: 2, name: "Daniel Ojo-williams", role: "Engineering", image: team2 },
    { id: 3, name: "Joseph Oyebamiji", role: "Engineering", image: team3 },
    { id: 4, name: "Omobolanle Afolabi", role: "Engineering", image: team4 },
    { id: 5, name: "Olayinka Bolaji", role: "Co-Founder & CEO", image: team5 },
    { id: 6, name: "Oluwatimilehin Labode", role: "Design", image: team6 },
    { id: 7, name: "Moses Oluwasanmi", role: "Design", image: team7 },
    { id: 8, name: "Peter Adebayo", role: "Engineering", image: team8 },
    { id: 9, name: "Mubarak Oguntunde", role: "Engineering", image: team9 },
    { id: 10, name: "Rachael Momoh", role: "Marketing", image: team10 }
  ];

  return (
    <div className="team-page">
      <div className="team-container">
        <div className="core-section">
          <h1>Our Mission</h1>
          <p>
          We are an EdTech solutions company on a mission to make school management simple,
          smart, and accessible for everyone.
          </p>
        </div>

        <div className="core-section">
          <h1>Our Vision</h1>
          <p>
          To transform education across emerging markets by 2030, reaching 10,000 schools and improving the learning experience of over 1 million students.
          </p>
        </div>

        <div className="team-section">
          <h1>The Team</h1>
          <p>
          Brilliant Minds with different skills but unified in purpose
          </p>

          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-member">
                <div className="member-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
